// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.block-text{display:flex;justify-content:center;flex-direction:column}.block-container img{max-width:100%}`, "",{"version":3,"sources":["webpack://./resources/app/modules/course/CourseBuilder/Blocks/TextBlock/index.scss"],"names":[],"mappings":"AAAA,YACE,YAAA,CACA,sBAAA,CACA,qBAAA,CAGA,qBACE,cAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
